export const webClientId = '814335805675-hclk77is8qa3qksf88kiragqj5qplij6.apps.googleusercontent.com'